import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API, formatApiError } from "@/App";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Download, Loader2, AlertCircle, FileVideo } from "lucide-react";

const SharedPage = () => {
  const { shareToken } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/shared/${shareToken}`);
        setData(res.data);
      } catch (err) { setError(formatApiError(err)); }
      finally { setLoading(false); }
    };
    fetch();
  }, [shareToken]);

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="fixed inset-0 bg-gradient-hero -z-10" />
      <Loader2 className="w-6 h-6 animate-spin text-cyan-400/40" />
    </div>
  );

  if (error) return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="fixed inset-0 bg-gradient-hero -z-10" />
      <div className="text-center">
        <div className="w-16 h-16 mx-auto border border-red-400/30 rounded-sm flex items-center justify-center mb-8"><AlertCircle className="w-8 h-8 text-red-400" /></div>
        <h1 className="text-2xl font-['Rajdhani'] tracking-wide mb-2">INVALID LINK</h1>
        <p className="text-cyan-200/40">{error}</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen" data-testid="shared-page">
      <div className="fixed inset-0 bg-gradient-hero -z-10" />

      <header className="border-b border-cyan-500/10 backdrop-blur-sm bg-[#020a14]/60">
        <div className="max-w-[800px] mx-auto px-6 py-8">
          <img src="/assets/logo.png" alt="MasteringMate" className="h-7" />
          <p className="text-sm text-cyan-200/30 mt-1">Shared Downloads</p>
        </div>
      </header>

      <main className="max-w-[800px] mx-auto px-6 py-12">
        <h2 className="text-sm text-cyan-400/60 mb-6 tracking-widest uppercase">Available Files</h2>
        {data?.outputs?.length > 0 ? (
          <div className="space-y-3">
            {data.outputs.map(out => (
              <div key={out.id} className="flex items-center justify-between p-6 card-glass rounded-sm" data-testid={`output-${out.id}`}>
                <div className="flex items-center gap-4">
                  <FileVideo className="w-5 h-5 text-cyan-400/30" />
                  <div>
                    <p className="capitalize text-cyan-200/80">{out.preset}</p>
                    <p className="text-sm text-cyan-200/30">{out.size ? `${(out.size / 1024 / 1024).toFixed(1)} MB` : "Video"}</p>
                  </div>
                </div>
                <Button onClick={() => window.open(`${API}/shared/${shareToken}/download/${out.id}`, "_blank")} className="h-10 px-6 rounded-sm btn-primary font-['Rajdhani'] tracking-wider text-sm" data-testid={`download-${out.id}`}>
                  <Download className="w-4 h-4 mr-2" />DOWNLOAD
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16 card-glass rounded-sm">
            <FileVideo className="w-10 h-10 mx-auto text-cyan-500/20 mb-4" />
            <p className="text-cyan-200/40">No files available</p>
          </div>
        )}
        <p className="text-center text-sm text-cyan-500/30 mt-8">Files expire 14 days after creation</p>
      </main>
    </div>
  );
};

export default SharedPage;
